import MD5 from './md5'

export function generateUUID() {
  var d = new Date().getTime()
  if (global.performance && typeof global.performance.now === 'function') {
    d += performance.now() //use high-precision timer if available
  }
  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0
      d = Math.floor(d / 16)
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16)
    }
  )
  return uuid
}

export function getTs() {
  const ts = parseInt(new Date().getTime() / 1000)
  return ts
}

export function getSign(obj) {
  const ts = getTs()
  obj.ts = ts

  function getReqStr(obj) {
    var _arr = [];
    for (var key in obj) {
      if (typeof obj[key] == "object") {
        // 二级对象递归调用
        var _str = getReqStr(obj[key]);
        _arr.push(key + "=" + _str);
      } else {
        _arr.push(key + "=" + obj[key]);
      }
    }
    _arr.sort();
    return _arr.join("&")
  }

  // const secret_key = '582a15ce3f1225f5c1ba7495704e3dd5'
  const secret_key = 'bfdd7345e4536e3bc2bfb3a3ea30d476'

  const unsign_str = getReqStr(obj) + secret_key
  const sign = MD5(unsign_str)
  return sign
}

export function throttle(func, delay) {
  console.log('here');
  let timer;
  return function () {
    const context = this;
    const args = arguments;
    console.log(timer, context, args);
    if (!timer) {
      timer = setTimeout(() => {
        console.log('要执行');
        func.apply(context, args);
        timer = null;
      }, delay);
    }
  };
}

export function isAndroid() {
  let android = navigator.userAgent.match(/(Android);?[\s\/]+([\d.]+)?/);
  if (android) {
    return android[2];
  }
  else {
    return '';
  }
}

export function formatTime(timestamp) {
  const date = new Date(timestamp * 1000);
  console.log(date)
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hour = date.getHours().toString().padStart(2, '0');
  const minute = date.getMinutes().toString().padStart(2, '0');
  const second = date.getSeconds().toString().padStart(2, '0');
  return `${year}/${month}/${day}`;
}